// Download-Karte "Prüfungsunterlagen" — nur für die Externenprüfung PFA.
import React from 'react';
import { Download, FileText, FileSignature } from 'lucide-react';

const DOCS = [
  {
    file: '/docs/Checkliste_Unterlagen_Externenpruefung_PFA.pdf',
    icon: FileText,
    title: 'Checkliste: Ihre Unterlagen',
    desc: 'Welche Dokumente Sie bis wann bei uns im Büro einreichen — mit allen Fristen.',
    testid: 'download-checkliste-pfa',
  },
  {
    file: '/docs/Vorlage_Arbeitgeberbescheinigung_PFA.pdf',
    icon: FileSignature,
    title: 'Arbeitgeber-Bescheinigung (Vorlage)',
    desc: 'Geben Sie diese Vorlage Ihrem Arbeitgeber zum Ausfüllen — sie enthält alles, was die Behörde braucht.',
    testid: 'download-agbescheinigung-pfa',
  },
];

const PRAKTIKUM_DOCS = [
  {
    file: '/docs/Praktikumsvertrag_FB_TN_07.pdf',
    icon: FileSignature,
    title: 'Praktikumsvertrag (FB_TN_07)',
    desc: 'Dreiseitige Vereinbarung für Ihr Praktikum — von Ihnen, dem Betrieb und uns zu unterschreiben.',
    testid: 'download-praktikumsvertrag',
  },
  {
    file: '/docs/Laufzettel_Praktikum_Pflegehilfskraft.pdf',
    icon: FileText,
    title: 'Praktikums-Laufzettel (FB_TN_08)',
    desc: 'Für Ihr 5-Tage-Praktikum: Aufgaben abzeichnen lassen und am Ende von der Praxisanleitung unterschreiben lassen.',
    testid: 'download-laufzettel-praktikum',
  },
  {
    file: '/docs/Praktikums_Bewertung_FB_TN_09.pdf',
    icon: FileSignature,
    title: 'Praktikums-Bewertung (FB_TN_09)',
    desc: 'Bewertungsbogen für Ihre Praxisanleitung — wird am Ende des Praktikums ausgefüllt und unterschrieben.',
    testid: 'download-bewertungsbogen-praktikum',
  },
];

export const PraktikumsunterlagenCard = () => (
  <aside className="mb-8 rounded-xl bg-cream-100 border border-cream-300" data-testid="praktikumsunterlagen-card">
    <div className="px-5 sm:px-6 pt-5">
      <p className="font-mono text-[9.5px] uppercase font-semibold tracking-[0.22em] text-terra">Praktikum · 40 Zeitstunden · Pflichtbestandteil</p>
      <h3 className="font-display text-xl text-espresso mt-0.5">Ihre Praktikumsunterlagen</h3>
      <p className="text-[13px] text-sand-600 mt-1.5 leading-snug" data-testid="praktikum-intro-text">
        Für den erfolgreichen Abschluss dieser Maßnahme absolvierst du ein einwöchiges Praktikum (5 Tage × 8 Zeitstunden = 40 Zeitstunden) in einer stationären oder ambulanten Pflegeeinrichtung deiner Wahl.
      </p>
    </div>
    <div className="px-5 sm:px-6 py-4 grid sm:grid-cols-2 gap-3">
      {PRAKTIKUM_DOCS.map((d) => (
        <a
          key={d.testid}
          href={d.file}
          target="_blank"
          rel="noreferrer"
          className="group flex items-start gap-3 p-4 rounded-lg bg-cream-50 border border-cream-300 hover:border-terra/40 transition-colors"
          data-testid={d.testid}
        >
          <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-terra/10 flex items-center justify-center">
            <d.icon className="w-4.5 h-4.5 text-terra" strokeWidth={1.7} />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-[13.5px] font-semibold text-espresso leading-snug">{d.title}</p>
            <p className="text-[12px] text-sand-600 mt-0.5 leading-snug">{d.desc}</p>
            <span className="inline-flex items-center gap-1 mt-2 text-[10.5px] font-bold uppercase tracking-wider text-terra group-hover:underline">
              <Download className="w-3 h-3" /> PDF herunterladen
            </span>
          </div>
        </a>
      ))}
    </div>
  </aside>
);

export const PruefungsunterlagenCard = () => (
  <aside className="mb-8 rounded-xl bg-cream-100 border border-cream-300" data-testid="pruefungsunterlagen-card">
    <div className="px-5 sm:px-6 pt-5">
      <p className="font-mono text-[9.5px] uppercase font-semibold tracking-[0.22em] text-terra">Zulassung zur Prüfung</p>
      <h3 className="font-display text-xl text-espresso mt-0.5">Ihre Prüfungsunterlagen</h3>
    </div>
    <div className="px-5 sm:px-6 py-4 grid sm:grid-cols-2 gap-3">
      {DOCS.map((d) => (
        <a
          key={d.testid}
          href={d.file}
          target="_blank"
          rel="noreferrer"
          className="group flex items-start gap-3 p-4 rounded-lg bg-cream-50 border border-cream-300 hover:border-terra/40 transition-colors"
          data-testid={d.testid}
        >
          <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-terra/10 flex items-center justify-center">
            <d.icon className="w-4.5 h-4.5 text-terra" strokeWidth={1.7} />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-[13.5px] font-semibold text-espresso leading-snug">{d.title}</p>
            <p className="text-[12px] text-sand-600 mt-0.5 leading-snug">{d.desc}</p>
            <span className="inline-flex items-center gap-1 mt-2 text-[10.5px] font-bold uppercase tracking-wider text-terra group-hover:underline">
              <Download className="w-3 h-3" /> PDF herunterladen
            </span>
          </div>
        </a>
      ))}
    </div>
  </aside>
);
